import { render } from "./HeaderVideo.vue?vue&type=template&id=e4ef5e68&scoped=true"
import script from "./HeaderVideo.vue?vue&type=script&lang=js"
export * from "./HeaderVideo.vue?vue&type=script&lang=js"

import "./HeaderVideo.vue?vue&type=style&index=0&id=e4ef5e68&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ef5e68"]])

export default __exports__